import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-col justify-between bg-gray-700 dark:bg-dark-300 left-0 h-full sm:shadow-none shadow-xl sm:relative sm:flex hidden px-2 pb-2" }
const _hoisted_2 = { class: "flex w-full justify-center py-4" }
const _hoisted_3 = { class: "flex flex-col h-full w-full -mt-3 text-white" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex flex-col h-full w-full -mt-3 text-white" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar_badge = _resolveComponent("avatar-badge")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      (_ctx.user)
        ? (_openBlock(), _createBlock(_component_avatar_badge, {
            key: 0,
            user: _ctx.user,
            "fallback-name": "main",
            "show-configuration": false
          }, null, 8, ["user"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (l) => {
        return (_openBlock(), _createElementBlock("li", {
          key: l.icon,
          class: "flex justify-center w-full"
        }, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => (_ctx.onClick(l)),
            class: "flex items-center text-center w-full py-2 text-xl hover:text-primary-200 transition-colors cursor-pointer"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(["w-12 mt-4", l.icon])
            }, null, 2)
          ], 8, _hoisted_4)), [
            [_directive_tooltip, {content: l.label, offset: [0, -17], arrow: false}]
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerBtns, (l) => {
          return (_openBlock(), _createElementBlock("li", {
            key: l.icon,
            class: "flex justify-center w-full"
          }, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.onClick(l)),
              class: "flex items-center text-center w-full py-2 text-xl hover:text-primary-200 transition-colors cursor-pointer"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["w-12 mt-4", l.icon])
              }, null, 2)
            ], 8, _hoisted_6)), [
              [_directive_tooltip, {content: l.label, offset: [0, -17], arrow: false}]
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}